import React, { useState } from "react";
import { RefundRequestFilters, RefundRequestStatusFilter } from "../../common/types";

export interface FiltersContextInterface {
  status: RefundRequestStatusFilter;
  setStatus: (status: RefundRequestStatusFilter) => void;
  cursor: string;
  setCursor: (cursor: string) => void;
  goBackwards: boolean;
  setGoBackwards: (goBackwards: boolean) => void;
  subOrderId: string;
  setSubOrderId: (subOrderId: string) => void;
}

export const FiltersContext = React.createContext<FiltersContextInterface>({
  status: RefundRequestFilters.Incomplete,
  setStatus: () => {},
  cursor: "",
  setCursor: () => {},
  goBackwards: false,
  setGoBackwards: () => {},
  subOrderId: "",
  setSubOrderId: () => {},
});

export const Filters: React.FC = ({ children }) => {
  const [status, setStatus] = useState<RefundRequestStatusFilter>(RefundRequestFilters.Incomplete);
  const [cursor, setCursor] = useState<string>("");
  const [goBackwards, setGoBackwards] = useState<boolean>(false);
  const [subOrderId, setSubOrderId] = useState<string>("");

  const contextValue: FiltersContextInterface = {
    status,
    setStatus,
    cursor,
    setCursor,
    goBackwards,
    setGoBackwards,
    subOrderId,
    setSubOrderId,
  };

  return <FiltersContext.Provider value={contextValue}>{children}</FiltersContext.Provider>;
};
